import './images.scss';
import 'slick-carousel';
export default (() => {
  $('.js-image-slider').slick({
    rows: 0,
    dots: false,
    arrows: true,
    infinite: false,
    prevArrow: '<button class="slick-prev button button--io" aria-label="Previous" type="button"><i class="far fa-arrow-left"></i></button>',
    nextArrow: '<button class="slick-next button button--io" aria-label="Next" type="button"><i class="far fa-arrow-right"></i></button>',
    speed: 300,
    swipeToSlide: true
  });
});